import { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom';
import './App.css';
import ScrollToTop from './ScrollToTop';


// lazy loading components

const SinglePage = lazy(() => import('./components/SinglePage'));

/**
 * main app component
 * holds banner and handles routing
 */
const App = () => {

  return (

    <Router>

      <ScrollToTop />

      <div className={'App'}>

        <main>
        

          <Suspense fallback={<div>Loading...</div>}>
            <Routes>
              <Route path="/" element={<SinglePage />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </Suspense>

        </main>

      </div>
      
    </Router>
  );
}

export default App;
